import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { combustiveisModuleName, combustiveisStorage } from "../shared/data.service";
import { Combustivel } from "../shared/combustivel.model";
import { editRoute, newRoute, configuracaoModuleName } from "../../../shared/services/data.service";
import { CombustivelNavigationService } from "../shared/combustivel-navigation.service";
import { CombustivelApiService } from "../shared/combustivel-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { CombustivelService } from "../shared/combustivel.service";
import { abastecimentosRoute, abastecimentosModuleName } from "../../shared/data.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";

@Component({
    template: require('./combustivel-form.component.html'),
    styles: [require('./combustivel-form.component.css')]
})
export class CombustivelFormComponent implements OnInit {
    abastecimentosRoute: string = abastecimentosRoute;
    combustiveisModule: any = combustiveisModuleName;
    formObject: any = new Combustivel();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    form: FormGroup;
    ativo = new FormControl('');
    combustivel = new FormControl('', Validators.required);
    codigoTCE = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseCombustivel: any;

    constructor(
        private _route: ActivatedRoute,
        private _combustivelNavigationService: CombustivelNavigationService,
        private _combustivelApiService: CombustivelApiService,
        private _combustivelService: CombustivelService,
        private _utilService: UtilService,
        private _abastecimentoService: AbastecimentoService,
        private _autocompleteService: AutoCompleteService,

        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            combustivel: this.combustivel,
            codigoTCE: this.codigoTCE
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:Combustivel = this._utilService.cloneObject(this.formObject);

            if (this.formObject.id) {
                this.onEditCombustivel(object);
            } else {
                this.onAddCombustivel(object);
            }
        }
    }

    private onAddCombustivel(object: Combustivel) {
        this._combustivelApiService.onPost(object, this.onDone);
    }

    private onEditCombustivel(object: Combustivel) {
        this._combustivelApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseCombustivel = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum combustível encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._combustivelApiService.onGetById(id, onDone);
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(combustiveisStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.combustivel = newAutoComplete.combustivel;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private testSession() {
        var id: number;
        var session: any = this._combustivelService.getSessionStorage();
        this._combustivelService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {

    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._combustivelService.returnToOtherForm(this.otherForm, this.responseCombustivel);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._combustivelNavigationService.goToList();
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {

    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/combustivel-form/combustivel-form.component.ts
 **/